import React from 'react'
import { useScriptWithConsent, ScriptLoadResult } from '@news-mono/web-common'
import { ConsentLevel } from '@news-mono/web-common'
import { TaboolaProps } from './Taboola'
import { capitalize } from '@news-mono/web-common'
import { useTheme } from '@emotion/react'
import { isServerEnvironment } from '@news-mono/web-common'
import { useProduct } from '../../__product/useProduct'

let hasTaboolaLoaded = false

const taboolaProductName = {
    sevennews: '7news',
    perthnow: 'perthnow',
    thewest: 'thewest',
}

export const Taboola: React.FC<TaboolaProps> = ({
    articleId,
    locationType,
    taboolaContainerId,
}) => {
    const product = useProduct()
    const { section } = useTheme()

    let publisher: string
    if (isServerEnvironment() || !window.taboolaPublisher) {
        // Assumption: all of the sections on the west besides default are regionals
        if (product === 'thewest' && section !== 'default') {
            publisher = 'sevenwestmedia-network'
        } else if (section === 'community-news') {
            publisher = 'sevenwestmedia-cng'
        } else {
            publisher = `sevenwestmedia-${taboolaProductName[product]}`
        }

        if (!isServerEnvironment()) {
            window.taboolaPublisher = publisher
        }
    } else {
        publisher = window.taboolaPublisher
    }

    const [result, error] = useScriptWithConsent({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,

        consentMet: {
            src: `//cdn.taboola.com/libtrc/${publisher}/loader.js`,
        },
    })

    React.useEffect(() => {
        if (window._taboola === undefined) {
            window._taboola = []
            // window.performance.mark is not a function in tests and unsupported in older browsers
            if (
                process.env.NODE_ENV !== 'test' &&
                typeof window.performance?.mark === 'function'
            ) {
                window.performance.mark('tbl_ic')
            }
        }
    }, [])

    React.useEffect(() => {
        if (result === ScriptLoadResult.Success) {
            if (hasTaboolaLoaded) {
                window._taboola.push({ notify: 'newPageLoad' })
            } else {
                hasTaboolaLoaded = true
            }

            // TODO Fix type error here
            window._taboola.push({
                [locationType]: 'auto',
                url: window.location.href,
            } as any)

            window._taboola.push({
                mode: 'alternating-thumbnails-a',
                container: taboolaContainerId,
                placement: `Below ${capitalize(locationType)} Thumbnails`,
                target_type: 'mix',
            })
        }
    }, [result, error, articleId, taboolaContainerId, locationType])

    return <div id={taboolaContainerId}></div>
}
Taboola.displayName = 'Taboola'

export default Taboola
